import { registerMutation, useMutation } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
const FILE_MANAGER_URL = 'filemanager/api/v3/files/';
export const FILE_UPLOAD_URL = `${FILE_MANAGER_URL}upload`;
const COMMON_FILE_UPLOAD_PARAMS = {
  timeout: 0,
  headers: {
    'content-type': false
  }
};
const UPLOAD_FILE_MANAGER = registerMutation({
  fieldName: 'fileManagerData',
  args: ['formData'],
  fetcher({
    formData
  }) {
    return formData && http.post(FILE_UPLOAD_URL, Object.assign({
      data: formData
    }, COMMON_FILE_UPLOAD_PARAMS));
  }
});
export const useUploadFile = options => {
  const [uploadFile, {
    loading: uploading,
    data,
    error: fileUploadError
  }] = useMutation(UPLOAD_FILE_MANAGER, Object.assign({
    fetchPolicy: 'network-only'
  }, options));
  return {
    data,
    uploading,
    fileUploadError,
    uploadFile
  };
};